import { CdkFixedSizeVirtualScroll, CdkVirtualForOf, CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { AsyncPipe, NgClass } from '@angular/common';
import { Component, forwardRef } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { UntilDestroy } from '@ngneat/until-destroy';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { FilterPipe } from '../../../../../../shared/pipes/filter/filter.pipe';
import { SortStringPipe } from '../../../../../../shared/pipes/sort-string/sort-string.pipe';
import { EzInputComponent } from '../../../../../../shared/components/ez-input/ez-input.component';
import { EzInputDirective } from '../../../../../../shared/components/ez-input/ez-input.directive';
import {
  FullAddressStepAbstract
} from 'src/app/layout/common/components/order-form/step-address/full-address-step.abstract';

@UntilDestroy()
@Component({
    selector: 'app-full-address-step',
    templateUrl: './full-address-step.component.html',
    styleUrls: ['./full-address-step.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FullAddressStepComponent),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => FullAddressStepComponent),
            multi: true,
        }
    ],
    imports: [
    NgClass,
    AsyncPipe,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    NgxMatSelectSearchModule,
    CdkVirtualScrollViewport,
    CdkFixedSizeVirtualScroll,
    CdkVirtualForOf,
    MatInputModule,
    FilterPipe,
    SortStringPipe,
    EzInputComponent,
    EzInputDirective
]
})
export class FullAddressStepComponent extends FullAddressStepAbstract { }
